module.exports = __webpack_public_path__ + "static/media/spinner.0c2072b7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spinner.gif
// module id = 816
// module chunks = 0